import Grid from '@material-ui/core/Grid';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Image from './Image';
import { convertMJD, mjdDifferenceInMinutes, displayMinutes } from '../utils/timeUtils';
import './Camera.css';

const camName = 'kcam';

function KCamera(props) {
  const { camData, imgSrc, metStat } = props;
  const { obs, zp, sky, mjd } = camData;
  let minSinceChange = mjdDifferenceInMinutes(mjd, convertMJD(new Date()));

  return (
    <Grid
      container
      direction='row'
      className='cam-card in-range'
    >
      <Grid item xs={6}>
        <Image imgSrc={imgSrc} style={{ width: 'auto', height: '125px' }} />
      </Grid>
      <Grid item xs={5}>
        <div>
          <h4>{metStat}</h4>
        </div>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell style={{ padding: '2px' }}>{obs}</TableCell>
              </TableRow>
            </TableHead>
          </Table>
          <Table>
            <TableBody>
              <TableRow key='zp'>
                <TableCell style={{ padding: '2px' }}>ZP</TableCell>
                <TableCell style={{ padding: '2px' }}>
                  {(zp == null) ? 'N/A' : parseFloat(zp).toFixed(2)}
                </TableCell>
              </TableRow>
              <TableRow key='sky'>
                <TableCell style={{ padding: '2px' }}>sky</TableCell>
                <TableCell style={{ padding: '2px' }}>
                  {(sky == null) ? 'N/A' : parseFloat(sky).toFixed(2)}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        {
          minSinceChange > 15 && (
            <div>
              <p>{displayMinutes(minSinceChange)}</p>
            </div>)
        }
      </Grid>
    </Grid>
  );
};

export default KCamera;